export const crestTypes = ['Gilded', 'Runed', 'Carved', 'Weathered'] as const

type CrestType = typeof crestTypes[number]
export default CrestType
